import { Integrator } from "./integrator";

export class IntegratorVenue {
	integratorKey: string;

	venueKey: number;

	integrator?: Integrator;

	public constructor(init?: Partial<IntegratorVenue>) {
		Object.assign(this, init);
	}
}
